module.exports = __webpack_public_path__ + "static/media/chicken8.90c558d4.jpg";